/** Rows per trade-history page. */
export const PAGE_SIZE = 12;

/** Separator for multi-value history filters in the URL query. */
export const DIVIDER_CHAR = '.';
